/* Mara product pages (sections/mara-product.liquid). Scoped to #mh.mp. */
(() => {
  /* F13: load the "Complete the set" script (assets/mara-set.js) */
  if (!window.MaraSet && !document.querySelector('script[data-mara-set]') && document.currentScript) {
    const s = document.createElement('script');
    s.src = document.currentScript.src.replace(/mara-(home|product)\.js/, 'mara-set.js');
    s.defer = true; s.dataset.maraSet = '1';
    document.head.appendChild(s);
  }
  const root = document.querySelector('#mh.mp');
  if (!root) return;
  const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Reveal on scroll */
  const io = 'IntersectionObserver' in window && new IntersectionObserver((es) => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  }), { rootMargin: '0px 0px -10% 0px' });
  root.querySelectorAll('[data-reveal]').forEach(el => io ? io.observe(el) : el.classList.add('in'));

  /* Photo thumbnails */
  const main = root.querySelector('[data-main-img]');
  root.querySelectorAll('[data-thumb]').forEach(t => t.addEventListener('click', () => {
    if (!main) return;
    main.src = t.dataset.src; main.removeAttribute('srcset');
    main.parentElement.classList.toggle('studio', t.dataset.studio === 'true');
    root.querySelectorAll('[data-thumb]').forEach(o => o.setAttribute('aria-current', String(o === t)));
  }));

  /* Options: 1 bottle, 3 bottles, monthly */
  const opts = root.querySelector('form[data-opts]');
  if (opts) {
    const sync = () => {
      const r = opts.querySelector('input[name=opt]:checked'); if (!r) return;
      opts.elements.id.value = r.dataset.id;
      opts.elements.selling_plan.value = r.dataset.plan || '';
      const pr = opts.querySelector('[data-opt-price]'); if (pr) pr.textContent = r.dataset.price;
    };
    opts.addEventListener('change', sync); sync();
  }

  /* Add to bag + panel */
  const panel = root.querySelector('[data-added]');
  const upsell = panel && panel.querySelector('[data-upsell]');
  const upBtn = panel && panel.querySelector('[data-upsell-btn]');
  const upMsg = panel && panel.querySelector('[data-upsell-msg]');
  const V1 = Number(root.dataset.v1);
  let hideT;
  const setText = (t) => { const s = panel.querySelector('[data-added-text] span'); if (s) s.textContent = t; };
  const setCount = (n) => root.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = n; el.dataset.full = n > 0; });
  const addItem = async (item) => {
    const res = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
    const cart = await fetch(base + 'cart.js').then(r => r.json());
    setCount(cart.item_count);
    return { data, cart };
  };
  const count = (c) => `${c.item_count} ${c.item_count === 1 ? 'item' : 'items'} in your bag.`;
  function showPanel(text, offer, keep) {
    setText(text);
    if (upsell) upsell.hidden = !offer;
    if (upMsg) upMsg.hidden = true;
    panel.hidden = false;
    setTimeout(() => panel.classList.add('show'), 20);
    clearTimeout(hideT);
    if (!offer && !keep) hideT = setTimeout(closePanel, 7000);
  }
  function closePanel() { clearTimeout(hideT); panel.classList.remove('show'); setTimeout(() => { panel.hidden = true; }, 400); }
  if (panel) {
    panel.querySelector('[data-added-close]').addEventListener('click', closePanel);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !panel.hidden) closePanel(); });
  }

  root.querySelectorAll('form[data-add]').forEach(form => form.addEventListener('submit', async (e) => {
    if (!panel) return;
    e.preventDefault();
    const btn = form.querySelector('button[type=submit]');
    const err = form.querySelector('.mp-err');
    const fd = new FormData(form);
    const item = { id: Number(fd.get('id')), quantity: 1 };
    const plan = fd.get('selling_plan');
    if (plan) item.selling_plan = Number(plan);
    btn.setAttribute('aria-busy', 'true');
    if (err) err.hidden = true;
    try {
      const { data, cart } = await addItem(item);
      const it = (data.items && data.items[0]) || {};
      const setShown = window.MaraSet ? await window.MaraSet.update(cart) : false;
      showPanel(`${it.product_title || 'Added'}${plan ? ', monthly' : ''}. ${count(cart)}`, Boolean(!setShown && upsell && item.id === V1 && !plan), setShown);
    } catch (x) {
      if (err) { err.textContent = `${x.message}. Please try again.`; err.hidden = false; }
      else { form.submit(); }
    } finally { btn.removeAttribute('aria-busy'); }
  }));

  if (upBtn) upBtn.addEventListener('click', async () => {
    upBtn.setAttribute('aria-busy', 'true');
    upMsg.hidden = true;
    try {
      const { cart } = await addItem({ id: V1, quantity: 1 });
      upsell.hidden = true;
      setText(`One more added. ${count(cart)}`);
      hideT = setTimeout(closePanel, 7000);
    } catch (x) {
      upMsg.textContent = `${x.message}. Your first bottle is still in your bag.`;
      upMsg.hidden = false;
    } finally { upBtn.removeAttribute('aria-busy'); }
  });

  /* Reaction reel: tap to play with sound, one at a time */
  root.querySelectorAll('.mh-clip').forEach(clip => {
    const v = clip.querySelector('video'); const b = clip.querySelector('button');
    if (!v || !b) return;
    b.addEventListener('click', () => {
      root.querySelectorAll('.mh-clip.playing video').forEach(o => { if (o !== v) o.pause(); });
      v.muted = false; v.controls = true; v.preload = 'auto';
      clip.classList.add('playing');
      v.play().catch(() => {});
    });
    v.addEventListener('pause', () => { if (v.ended) { clip.classList.remove('playing'); v.controls = false; } });
  });
  const track = root.querySelector('[data-reel-track]');
  root.querySelectorAll('[data-reel]').forEach(btn => btn.addEventListener('click', () => {
    track.scrollBy({ left: Number(btn.dataset.reel) * track.clientWidth * 0.8, behavior: 'smooth' });
  }));

  /* Mobile buy bar: after the hero, hidden while the closing buy card is on screen */
  const bar = root.querySelector('[data-bar]');
  const hero = root.querySelector('#mh-hero'); const buy = root.querySelector('#buy');
  if (bar && hero && buy && 'IntersectionObserver' in window) {
    let heroOut = false, buyIn = false;
    const set = () => { const on = heroOut && !buyIn; bar.classList.toggle('show', on); bar.setAttribute('aria-hidden', String(!on)); bar.querySelector('button').tabIndex = on ? 0 : -1; };
    new IntersectionObserver(([e]) => { heroOut = !e.isIntersecting; set(); }).observe(hero);
    new IntersectionObserver(([e]) => { buyIn = e.isIntersecting; set(); }, { threshold: 0.15 }).observe(buy);
  }
})();